(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cm-acquisition"] && !Shopify.designMode) return;
  try {
    
(function(){
function setup(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 const form=root.querySelector('.cm-acq-form');if(!form)return;
 const strings=JSON.parse(root.querySelector('[data-cm-copy]').textContent),selects=[...root.querySelectorAll('.cm-acq-variant')],submit=root.querySelector('[data-add]'),summary=root.querySelector('[data-summary]'),error=root.querySelector('[data-error]');
 const originalDisabled=new Map(selects.map(s=>[s,s.disabled]));
 const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:root.dataset.currency||'USD'});
 function selections(){return selects.filter(s=>s.value&&!s.selectedOptions[0].disabled);}
 function refresh(){const picks=selections(),total=picks.reduce((n,s)=>n+Number(s.selectedOptions[0].dataset.price),0);summary.textContent=picks.length?strings.selected.replace('[count]',picks.length)+' · '+money.format(total/100):strings.nothing;submit.disabled=!picks.length;error.textContent='';for(const s of picks)s.closest('article').querySelector('[data-price]').textContent=money.format(Number(s.selectedOptions[0].dataset.price)/100);}
 selects.forEach(s=>s.addEventListener('change',refresh));
 form.addEventListener('submit',async e=>{
 e.preventDefault();const picks=selections();if(!picks.length)return;submit.disabled=true;selects.forEach(s=>s.disabled=true);submit.textContent=strings.adding;error.textContent='';
 const items=picks.map(s=>({id:Number(s.value),quantity:1,properties:{_cm_funnel:root.dataset.route}}));
 try{const path=window.Shopify?.routes?.root||'/';const response=await fetch(path+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});const result=await response.json();if(!response.ok)throw new Error(typeof result.description==='string'?result.description:strings.error);window.location.assign(path+'cart');}
 catch(err){error.textContent=err.message||strings.error;error.focus();submit.disabled=false;selects.forEach(s=>{s.disabled=originalDisabled.get(s)});submit.textContent=strings.add;}
 });
}
document.querySelectorAll('.cm-acq').forEach(setup);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.cm-acq').forEach(setup));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cm-footer"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cm-footer-accordions')) {
  customElements.define('cm-footer-accordions', class extends HTMLElement {
    connectedCallback() {
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.syncGroups = () => this.querySelectorAll('.cm-footer-group').forEach(group => { group.open = !this.mobile.matches; });
      this.syncGroups();
      this.mobile.addEventListener('change', this.syncGroups);
    }
    disconnectedCallback() { this.mobile?.removeEventListener('change', this.syncGroups); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cm-halloween-sale"] && !Shopify.designMode) return;
  try {
    
if(!window.cmSaleZoomInstalled){
  window.cmSaleZoomInstalled=true;
  document.addEventListener('click',function(event){
    const trigger=event.target.closest('[data-cm-zoom]');
    if(trigger){
      const root=trigger.closest('.cm-sale');
      const dialog=root?.querySelector('.cm-sell-zoom');
      if(!dialog)return;
      const image=dialog.querySelector('img');
      image.src=trigger.dataset.image;image.alt=trigger.dataset.name;
      dialog.querySelector('[data-zoom-name]').textContent=trigger.dataset.name;
      dialog.querySelector('[data-zoom-shop]').href=trigger.dataset.url;
      dialog.showModal();
    }
    const close=event.target.closest('.cm-sell-close');
    if(close)close.closest('dialog').close();
    if(event.target.matches('.cm-sell-zoom')){const bounds=event.target.getBoundingClientRect();if(event.clientX<bounds.left||event.clientX>bounds.right||event.clientY<bounds.top||event.clientY>bounds.bottom)event.target.close();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cm-shop-home"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const trigger=event.target.closest('[data-cm-quick]');
  if(trigger && typeof HTMLDialogElement!=='undefined'){
    const dialog=trigger.closest('.cm-shop-tile').querySelector('.cm-quick');
    if(dialog){event.preventDefault();dialog.showModal();dialog.querySelector('select').focus();}
  }
  const close=event.target.closest('[data-cm-close]');
  if(close)close.closest('dialog').close();
});
document.addEventListener('change', function(event){
  const select=event.target.closest('[data-cm-variant]');
  if(!select)return;
  const dialog=select.closest('dialog'),option=select.selectedOptions[0];
  dialog.querySelector('[data-cm-submit]').disabled=!select.value;
  if(option.dataset.price)dialog.querySelector('[data-cm-price]').textContent=option.dataset.price;
  if(option.dataset.image)dialog.querySelector('.cm-quick-photo').src=option.dataset.image;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cm-shop-the-look"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initialize(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const panels = [...root.querySelectorAll('[data-look-panel]')];
    const tabs = [...root.querySelectorAll('[data-look-tab]')];
    const activate = (id, scroll = false) => {
      const active = panels.find(panel => panel.id === id) || panels[0];
      if (!active) return;
      panels.forEach(panel => { panel.hidden = panel !== active; });
      tabs.forEach(tab => tab.setAttribute('aria-current', String(tab.dataset.lookTab === active.id)));
      if (scroll) active.scrollIntoView({ behavior: 'instant', block: 'start' });
    };
    tabs.forEach(tab => tab.addEventListener('click', event => {
      event.preventDefault();
      history.replaceState(null, '', '#' + tab.dataset.lookTab);
      activate(tab.dataset.lookTab);
    }));
    activate(location.hash.slice(1));
    window.addEventListener('hashchange', () => activate(location.hash.slice(1), true));
    root.querySelectorAll('[data-look-form]').forEach(form => {
      const money = new Intl.NumberFormat(form.dataset.locale || 'en', { style: 'currency', currency: form.dataset.currency || 'USD' });
      const pieces = [...form.querySelectorAll('[data-piece]')].map(element => ({
        element,
        include: element.querySelector('[data-include]'),
        options: [...element.querySelectorAll('[data-option]')],
        variants: JSON.parse(element.querySelector('[data-variants]').textContent),
        variant: null
      }));
      const button = form.querySelector('[data-add]');
      const buttonText = button.firstChild;
      const status = form.querySelector('[data-status]');
      const error = form.querySelector('[data-error-message]');
      const cartLink = form.querySelector('[data-view-cart]');
      let busy = false;
      let uncertain = false;
      const sync = () => {
        let total = 0;
        let selected = 0;
        let valid = true;
        pieces.forEach(piece => {
          const active = piece.include.checked;
          const values = piece.options.map(option => option.value);
          piece.options.forEach(option => { option.disabled = !active || busy; });
          piece.include.disabled = busy || !piece.variants.some(variant => variant.available);
          piece.element.classList.toggle('is-excluded', !active);
          const size = piece.options.find(option => option.hasAttribute('data-size'));
          if (size) {
            const sizeIndex = Number(size.dataset.index);
            [...size.options].forEach(choice => {
              if (!choice.value) return;
              const available = piece.variants.some(variant => variant.available && variant.options.every((value, index) => index === sizeIndex ? value === choice.value : !values[index] || value === values[index]));
              choice.disabled = !available;
              choice.textContent = choice.value + (available ? '' : ' — ' + form.dataset.soldOut);
            });
            if (size.selectedOptions[0]?.disabled) {
              size.value = '';
              values[sizeIndex] = '';
            }
          }
          const match = piece.variants.find(variant => variant.options.every((value, index) => value === values[index]));
          const candidate = match || piece.variants.find(variant => variant.options.every((value, index) => !values[index] || value === values[index]));
          piece.variant = match?.available ? match : null;
          const amount = candidate?.price ?? Number(piece.element.dataset.basePrice);
          piece.element.querySelector('[data-piece-price]').textContent = money.format(amount / 100);
          piece.element.querySelector('[data-piece-message]').textContent = active && match && !match.available ? form.dataset.unavailable : (!piece.variants.some(variant => variant.available) ? form.dataset.soldOut : '');
          if (candidate?.image) {
            const images = [piece.element.querySelector('.cmlooks-item-photo img'), form.closest('[data-look-panel]').querySelector('.cmlooks-photo--' + piece.element.dataset.kind + ' img')];
            images.forEach(image => {
              if (image && image.dataset.variantImage !== candidate.image) {
                image.removeAttribute('srcset');
                image.src = candidate.image;
                image.dataset.variantImage = candidate.image;
              }
            });
          }
          if (active) { selected += 1; total += amount; valid = valid && Boolean(piece.variant); }
        });
        form.querySelector('[data-total]').textContent = money.format(total / 100);
        status.textContent = !selected ? form.dataset.choosePiece : !valid ? form.dataset.chooseSizes : '';
        button.disabled = busy || uncertain || !selected || !valid;
      };
      form.addEventListener('change', () => { sync(); });
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (busy || uncertain) return;
        sync();
        if (button.disabled) return;
        const items = pieces.filter(piece => piece.include.checked).map(piece => ({ id: piece.variant.id, quantity: 1 }));
        busy = true;
        error.hidden = true;
        form.setAttribute('aria-busy', 'true');
        buttonText.textContent = form.dataset.addingLabel;
        sync();
        try {
          const response = await fetch(form.dataset.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
          const result = await response.json();
          if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : form.dataset.error);
          window.location.assign(form.dataset.cartUrl);
        } catch (failure) {
          uncertain = true;
          error.textContent = (failure.message || form.dataset.error) + ' ' + form.dataset.retry;
          error.hidden = false;
          cartLink.hidden = false;
          error.tabIndex = -1;
          error.focus();
          busy = false;
          form.removeAttribute('aria-busy');
          buttonText.textContent = form.dataset.addLabel;
          sync();
        }
      });
      form.classList.add('is-ready');
      sync();
    });
  }
  document.querySelectorAll('[data-looks-page]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-looks-page]').forEach(initialize));
})();

  } catch(e) { console.error(e); }
})();
})();
